import {
  SCOUT_LARGE_PDF_MAX_BYTES,
  SCOUT_NATIVE_MAX_IMAGE_BYTES,
  SCOUT_NATIVE_MAX_TEXT_BYTES,
} from "./attachmentLimits";
import { findSupportedTextExtractionFormat } from "./supportedTextExtractionFormats";

export function validateScoutAttachment(input: {
  mediaType: string;
  sizeBytes: number;
  filename?: string;
}): string | undefined {
  const mimeType = input.mediaType.trim().toLowerCase();
  const extension = input.filename?.includes(".")
    ? input.filename.split(".").pop()?.toLowerCase()
    : undefined;

  if (mimeType === "application/pdf") {
    if (input.sizeBytes > SCOUT_LARGE_PDF_MAX_BYTES) {
      const sizeMiB = (input.sizeBytes / (1024 * 1024)).toFixed(2);
      return `File is larger than 200 MB (${sizeMiB} MB) and is not supported.`;
    }
    return undefined;
  }

  if (
    mimeType === "image/png" ||
    mimeType === "image/jpeg" ||
    mimeType === "image/gif" ||
    mimeType === "image/webp"
  ) {
    if (input.sizeBytes > SCOUT_NATIVE_MAX_IMAGE_BYTES) {
      const sizeMiB = (input.sizeBytes / (1024 * 1024)).toFixed(2);
      return `File is larger than 5 MB (${sizeMiB} MB).`;
    }
    return undefined;
  }

  if (mimeType === "text/plain") {
    if (input.sizeBytes > SCOUT_NATIVE_MAX_TEXT_BYTES) {
      return "File is larger than 200 KB.";
    }
    return undefined;
  }

  const textFormat = findSupportedTextExtractionFormat({
    mediaType: mimeType,
    extension,
  });
  if (textFormat) {
    if (input.sizeBytes > textFormat.maxUploadBytes) {
      const sizeMiB = (input.sizeBytes / (1024 * 1024)).toFixed(2);
      const maxMiB = (textFormat.maxUploadBytes / (1024 * 1024)).toFixed(0);
      return `File is larger than ${maxMiB} MB (${sizeMiB} MB) and is not supported.`;
    }
    return undefined;
  }

  return "File type is unsupported. Scout supports PDFs, images, plain text, and Office documents (DOCX, XLSX, PPTX), XML, and CSV.";
}
